type Callback = (container: Element) => void;

const callbacks: Callback[] = [];

export function register(callback: Callback): void {
    callbacks.push(callback);
}

export function init(container: Element): void {
    callbacks.forEach(cb => cb(container));
}
